
<template>
<div class="container">
    <div class="row justify-content-center">
        <div class="col-md-6 col-lg-6">
            <div class="card">
                <div class="card-body p-lg-4">
                    <div class="text-center">
                        <h3 class="mb-1 mt-0 text-primary">Login </h3>
                        <p class="mb-3 text-center" style="color:#999999">
                          Login with your email and password
                        </p>
                    </div>
                    <form action="#">
                        <div class="form-group mb-3">
                            <input v-model="data.email" v-validate="{ required: true, email: true }" name="emailaddress" 
                            :class="{ 'is-invalid': errors.has('emailaddress') }" class="form-control" type="email" id="emailaddress" placeholder="Enter your email" />
                        </div>
                        <div class="form-group mb-3">
                            <div class="input-group input-group-merge">
                                <input v-validate="'required|max:50'"
                                v-model="data.password" name="password"
                                :class="{ 'is-invalid': errors.has('password') }" :type="passwordType" id="password"
                                 class="form-control border-right-0" placeholder="Enter your password" />
                                <div class="input-group-append " style="cursor: pointer;" @click="passwordVisibility()">
                                    <div class="input-group-text bg-transparent border-left-0">
                                        <span class="password-eye"></span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group mb-3">
                            <div class="custom-control custom-checkbox">
                                <input v-model="data.remember" type="checkbox" class="custom-control-input" id="checkbox-signin" checked />
                                <label class="custom-control-label" for="checkbox-signin">Remember me</label>
                            </div>
                        </div>

                        <div class="form-group mb-0">
                            <button @click.prevent="submitData()" class="btn btn-block btn-primary" type="button">Log In</button>
                        </div>
                    </form>
                    <p class="mt-3 mb-0 text-center" style="color:#999999">
                      <a :href="absoluteUrl('/forgot-password')">Forgot password?</a>
                    </p>
                </div>
                <!-- end card-body -->
            </div>
            <!-- end card -->
        </div>
        <!-- end col -->
    </div>
</div>

<!-- end row -->
</template>

<script>
export default {
  data() {
    return {
      data: {
        email: '',
        password: '',
        role: 'worker',
        remember: true
      },
      passwordType: "password",

    }
  },
  methods: {
    passwordVisibility(){
        this.passwordType == "text" ? this.passwordType = "password" : this.passwordType = "text"
    },
    submitData(){
      this.$validator.validateAll().then(result => {
        if (!result) { this.alertError("Form Not Valid"); return;}
        this.$store.dispatch("changeLoaderValue", true)
        let formData = new FormData();
        formData.append('data', JSON.stringify(this.data));
        this.$http.post(this.absoluteUrl('/api/login'), formData)
        .then((response)=> {
          this.$store.dispatch("changeLoaderValue")
          if(response.data.success){
            this.resetForm()
            this.$store.commit("SET_AUTH_TOKEN", response.data.data)
            location.replace(this.$route.query.intended_url || '/')
          }
        })
      });
    },
    resetForm(){
      this.data = {
        email: '',
        password: '',
        role: 'worker',
        remember: true
      }
      this.$validator.reset()
    },
   },
  }
</script>
